import { render, staticRenderFns } from "./NsVTextField.vue?vue&type=template&id=31bc0f9e&scoped=true&"
import script from "./NsVTextField.vue?vue&type=script&lang=js&"
export * from "./NsVTextField.vue?vue&type=script&lang=js&"
import style0 from "./NsVTextField.vue?vue&type=style&index=0&id=31bc0f9e&scoped=true&lang=scss&"
import style1 from "./NsVTextField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc0f9e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bc0f9e')) {
      api.createRecord('31bc0f9e', component.options)
    } else {
      api.reload('31bc0f9e', component.options)
    }
    module.hot.accept("./NsVTextField.vue?vue&type=template&id=31bc0f9e&scoped=true&", function () {
      api.rerender('31bc0f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsVTextField.vue"
export default component.exports